<template>
  <div>
    <v-app-bar color="red" dark outlined app>
      <v-toolbar-title>Profile</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <div v-if="!isReady">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-two-line"
          v-for="i in 3"
          :key="i"
        />
      </div>

      <div v-else>
        <!-- Menu list -->
        <v-list flat>
          <v-list-item
            @click="
              $router.push({ name: 'Store', params: { id: user.store_id } })
            "
            v-if="isManager"
          >
            <v-list-item-content>
              <v-list-item-title>Toko</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <v-list-item @click="showChangePassword = true">
            <v-list-item-content>
              <v-list-item-title>Ubah Password</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <v-list-item @click="update">
            <v-list-item-content>
              <v-list-item-title>Force Update</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <v-list-item @click="logout">
            <v-list-item-content>
              <v-list-item-title>Keluar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </v-list>
        <!-- End list -->

        <div class="text-center font-weight-thin">
          v{{ version.version }}-{{ version.datetime }}
        </div>
      </div>

      <!-- Edit password dialog -->
      <ChangePassword
        v-if="showChangePassword"
        :showDialog="showChangePassword"
        v-on:close-dialog="showChangePassword = false"
      />

      <!-- Overlay -->
      <v-overlay :value="showOverlay" z-index="9999">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>

      <!-- Snackbar -->
      <v-snackbar v-model="showSnackbar" multi-line bottom>
        {{ textSnackbar }}
      </v-snackbar>

      <v-snackbar v-model="versionSnackbar" multi-line>
        Version: {{ version.version }}-{{ version.datetime }}
      </v-snackbar>
    </v-main>
  </div>
</template>

<script>
import store from "@/store";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "Profile",
  components: {
    ChangePassword: () =>
      import(
        /* webpackChunkName: "change-password" */
        "../../components/profile/ChangePassword"
      ),
  },
  data() {
    return {
      constant: store.state.constant,
      user: store.state.user,
      showChangePassword: false,
      textSnackbar: "",
      showSnackbar: false,
      showOverlay: false,
      versionSnackbar: false,
    };
  },
  methods: {
    update() {
      window.location.reload(true);
    },
    logout() {
      localStorage.clear();
      window.location.reload();
    },
  },
  computed: {
    ...mapState("appConstant", ["appConstant"]),
    isReady() {
      return this.appConstant.status;
    },
    isManager() {
      const userType = parseInt(store.state.user.type);
      const managerType = this.appConstant.data.USER_MANAGER;
      return userType === managerType;
    },
    version() {
      return {
        version: process.env.VUE_APP_VERSION,
        datetime: moment(process.env.VUE_APP_DATETIME).format("YYYYMMDD"),
      };
    },
  },
};
</script>

<style scoped>
</style>